import {BaseModel} from '.'

/**
 * School model
 */
class School extends BaseModel {
  defaults () {
    return {
      id: null,
      coordinator: null,
      email: '',
      name: '',
      address: '',
      zip: '',
      city: '',
      state: {
        code: '',
        name: ''
      },
      country: null
    }
  }

  loaded () {
    return this.name !== '' || this.country !== null
  }

  isCoordinator (userId) {
    return userId === this.coordinatorId
  }

  routes () {
    return {
      fetch: '/schools/{id}',
      save: '/schools/{id}',
      delete: '/schools/{id}',
      create: '/schools'
    }
  }

  options () {
    return {
      methods: {
        fetch: 'GET',
        create: 'POST',
        save: 'PATCH',
        update: 'PATCH'
      }
    }
  }
}

export {School}



//////////////////
// WEBPACK FOOTER
// ./src/models/School.js
// module id = 888
// module chunks = 1